import { flowRight } from 'lodash';
import { connect } from 'react-redux';
import { withCustomMetrics } from '@zocdoc/frontend-metrics';
import { InsurancePickerWithErrorOverride } from './InsurancePickerWithErrorOverride';
import {
    closeDropdown,
    openDropdown,
    registerGoogleAnalyticsCategory,
    registerLoggingSection,
    textBoxChange,
    registerRecordAbCarrierChosenByUser,
    registerRecordAbPlanChosenByUser,
} from '../../data/dropdown-state/dropdownStateActions';
import { handleAutocompleteChange } from '../../data/autocomplete';
import { getFocusCounter } from '../../data/focus';
import { getDropdownState } from '../../data/dropdown-state';

export function mapStateToProps(state, ownProps) {
    const dropdownState = getDropdownState(state);
    const focusCounter = getFocusCounter(state);

    const {
        gaCategory,
        errorStateOverride,
        showScanInsuranceCardButton,
    } = ownProps;

    return {
        ...dropdownState,
        gaCategory: gaCategory || dropdownState.gaCategory,
        isChange: dropdownState.showChange,
        isErrorState: dropdownState.showErrorState,
        errorStateOverride,
        focusCounter,
        showScanInsuranceCardButton,
    };
}

export const mapDispatchToProps = {
    closeDropdown,
    handleAutocompleteChange,
    openDropdown,
    registerRecordAbCarrierChosenByUser,
    registerRecordAbPlanChosenByUser,
    registerGoogleAnalyticsCategory,
    registerLoggingSection,
    textBoxChange,
};

export const InsurancePickerConnector = flowRight(
    withCustomMetrics({ component: 'InsurancePicker' }),
    connect(mapStateToProps, mapDispatchToProps)
)(InsurancePickerWithErrorOverride);
